/**
 * 明細テーブルのセル input に適用する共通クラス。
 * `hasError=true` で赤枠＋薄赤背景＋赤リング。
 *
 * 通常時は bg-transparent にして「行の色分け(<tr>/<td> の stripe)」を input まで透過させる
 * （白背景だと p-0 の td を input が覆い、行の色が見えなくなるため）。
 * 入力中は focus:bg-white で対象セルを白くして編集箇所を明確にする。
 */
export function detailCellInputClass(hasError: boolean): string {
  const base =
    'w-full min-w-0 box-border text-xs text-gray-900 border rounded px-1.5 py-1 m-0.5 focus:ring-1 focus:border-blue-400'
  return hasError
    ? `${base} border-red-500 bg-red-50 ring-1 ring-red-300 focus:ring-red-500`
    : `${base} border-gray-200 bg-transparent focus:bg-white focus:ring-blue-500`
}

// ── 明細テーブル 左側固定列（受給者 編集/詳細 で共用）──────────────────
// No. 列 + 確認 + メモ + データ先頭4列(f1〜f4) を横スクロール時も左に固定する。
// left は固定列幅の累積: No.=48px, 確認=75px, メモ=144px, データ列=104px(w-[6.5rem])。
// Tailwind JIT が拾えるよう left クラスは静的文字列で列挙する(動的生成だと未生成になる)。
export const NO_COL_WIDTH_PX = 48
export const REVIEW_COL_WIDTH_PX = 75
export const MEMO_COL_WIDTH_PX = 144
export const DATA_COL_WIDTH_PX = 104

export const REVIEW_COL_CLASS = 'w-[75px] min-w-[75px]'
export const REVIEW_COL_LEFT = 'left-[48px]'
export const MEMO_COL_LEFT = 'left-[123px]'

export const FROZEN_DATA_COL_COUNT = 4
export const FROZEN_LEFT_CLASS = ['left-[267px]', 'left-[371px]', 'left-[475px]', 'left-[579px]'] as const
/** 非凍結 f 列の scroll-margin（No.+確認+メモ+f1〜f4 の合計幅） */
export const FROZEN_SCROLL_ML_CLASS = 'scroll-ml-[683px]'

export const isFrozenDataCol = (colIdx: number) => colIdx < FROZEN_DATA_COL_COUNT
export const isLastFrozenDataCol = (colIdx: number) => colIdx === FROZEN_DATA_COL_COUNT - 1
